import { storableError } from '../../util/errors';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { parse } from '../../util/urlHelpers';

export const FETCH_HISTORY_REQUEST = 'app/HistoryPage/FETCH_HISTORY_REQUEST';
export const FETCH_HISTORY_SUCCESS = 'app/HistoryPage/FETCH_HISTORY_SUCCESS';
export const FETCH_HISTORY_ERROR = 'app/HistoryPage/FETCH_HISTORY_ERROR';

export const SET_PAGINATION_FOR_OTHER_TAB = 'app/HistoryPage/SET_PAGINATION_FOR_OTHER_TAB';

export const fetchHistoryRequest = () => ({ type: FETCH_HISTORY_REQUEST });
export const fetchHistorySuccess = response => ({ type: FETCH_HISTORY_SUCCESS, payload: response });
export const fetchHistoryError = error => ({ type: FETCH_HISTORY_ERROR, error });

export const setPaginationForOtherTab = (pagination) => ({
    type: SET_PAGINATION_FOR_OTHER_TAB,
    payload: pagination,
})

const sortedTransactions = txs =>
    reverse(
        sortBy(txs, tx => {
            return tx.attributes ? tx.attributes.lastTransitionedAt : null;
        })
    );

const entityRefs = entities =>
    entities.map(entity => ({
        id: entity.id,
        type: entity.type,
    }));

const initialState = {
    fetchInProgress: false,
    fetchError: null,
    pagination: null,
    otherPagination: null,
    transactionRefs: [],
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case FETCH_HISTORY_REQUEST:
            return {
                ...state,
                fetchInProgress: true,
                fetchError: null,
            };
        case FETCH_HISTORY_SUCCESS: {
            const transactions = sortedTransactions(payload.data.data);
            return {
                ...state,
                fetchInProgress: false,
                transactionRefs: entityRefs(transactions),
                pagination: payload.data.meta,
            };
        }
        case FETCH_HISTORY_ERROR:
            console.error(payload);
            return {
                ...state,
                fetchInProgress: false,
                fetchError: payload
            };

        case SET_PAGINATION_FOR_OTHER_TAB:
            return {
                ...state,
                otherPagination: payload,
            };

        default:
            return state;
    }
};

const getOtherPagination = params => (dispatch, getState, sdk) => {
    return sdk.transactions
        .query(params)
        .then(response => {
            const pagination = response.data.meta;
            dispatch(setPaginationForOtherTab(pagination));
            return pagination;
        })
        .catch(e => {
            console.log(e);
        });
};

export const loadData = (params, search) => (dispatch, getState, sdk) => {
    dispatch(fetchHistoryRequest());

    const { page = 1, tab } = parse(search);

    const apiQueryParams = {
        states: `state/delivered,
        state/received,
        state/completed,
        state/reviewed-by-customer,
        state/reviewed-by-provider,
        state/reviewed`,
        include: [
            'listing',
            'provider',
            'provider.profileImage',
            'customer',
            'customer.profileImage',
            'listing.images',
        ],
        'fields.transaction': [
            'processName',
            'lastTransition',
            'lastTransitionedAt',
            'transitions',
            'payinTotal',
            'payoutTotal',
            'lineItems',
        ],
        'fields.listing': ['title', 'publicData', 'deleted'],
        'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'deleted', 'banned'],
        'fields.image': [
            'variants.square-small',
            'variants.square-small2x',
            'variants.default',
        ],
        sort: "lastTransitionedAt",
    };

    dispatch(getOtherPagination({
        ...apiQueryParams,
        only: tab == 'order' ? 'sale' : 'order',
        perPage: 1,
        page: 1,
    }));

    return sdk.transactions
        .query({
            ...apiQueryParams,
            only: tab || 'order',
            page,
            // perPage: 24,
        })
        .then(response => {
            dispatch(addMarketplaceEntities(response));
            dispatch(fetchHistorySuccess(response));
            return response;
        })
        .catch(e => {
            dispatch(fetchHistoryError(storableError(e)));
            throw e;
        });
};
